import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from "@material-ui/core/Drawer";
const styles = theme => ({
  drawer: {
    '& > div': {
      top: 68,
      zIndex: 999,
      backgroundColor: '#97a7bd',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
      borderRight: 0,
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    }
  },
  container: {
    backgroundColor: '#97a7bd',
    color: '#fff',
    width: '300px',
    zIndex: 999
  }
});
const DefiSidebar = props => {
  const classes = props.classes;
  return /*#__PURE__*/React.createElement(Drawer, {
    variant: "persistent",
    open: props.open,
    className: classes.drawer,
    "data-testid": "defi-sidebar"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("br", null), props.children));
};
export default withStyles(styles)(DefiSidebar);